import React from 'react';
import styled from '@emotion/styled';
import { InventoryItem, InventoryStatus } from '../../types';
import { useUpdateInventoryItemStatus } from '../../hooks/useUpdateInventoryItemStatus';
import { InventoryStatusSidebar } from './InventoryStatusSidebar';
import { InventoryItemFieldRow } from './InventoryItemFieldRow';
import { InventoryItemNoteRow } from './InventoryItemNoteRow';
import { useNamespacedTranslation } from '../../../../../../../hooks/useNamespacedTranslation';
import {
  ExtraFieldsViewArea,
  ExtraFieldsValueToRender,
} from '../../../../../components/ExtraFields';
import {
  ExtraFieldsFormId,
  ExtraFieldsSupportedObject,
} from '../../../../../components/ExtraFields/types';

type Props = {
  inventoryItem: InventoryItem;
  isManager: boolean;
};

const i18Path = 'myData.inventory.sidebarModal.information';

export const InventoryInformationTab: React.FC<Props> = ({
  inventoryItem,
  isManager,
}) => {
  const { updateStatus, loading } = useUpdateInventoryItemStatus();
  const t = useNamespacedTranslation(i18Path);

  const handleUpdateInventoryItemStatus = (status: InventoryStatus) => {
    updateStatus(inventoryItem.id, status);
  };

  const renderExtraFieldItems = (items: ExtraFieldsValueToRender[]) => {
    return (
      <>
        {items.map((item) =>
          item.isRichTextArea && item.inputValue ? (
            <InventoryItemNoteRow
              key={item.fieldApiName}
              label={item.label}
              value={item.inputValue}
            />
          ) : (
            <InventoryItemFieldRow
              key={item.fieldApiName}
              label={item.label}
              value={item.inputValue}
            />
          ),
        )}
      </>
    );
  };

  return (
    <StyledInfoWrapper>
      <div className="d-flex flex-column gap-4">
        <ExtraFieldsViewArea
          objectApiName={ExtraFieldsSupportedObject.InventoryItem}
          formId={ExtraFieldsFormId.InventoryItemDetails}
          recordId={inventoryItem.id}
          renderItems={renderExtraFieldItems}
        />
        {inventoryItem.status && (
          <InventoryStatusSidebar
            hasUpdateAccess={isManager}
            isLoading={loading}
            handleStatusUpdate={handleUpdateInventoryItemStatus}
            label={t('status')}
            status={inventoryItem.status}
          />
        )}
      </div>
    </StyledInfoWrapper>
  );
};

const StyledInfoWrapper = styled.div`
  overflow-y: auto;
  max-height: 50rem;
`;
